import { produce } from "immer";
import type { ImmerActionInput } from "../types";
import {
  SET_PRINTER_HOST,
  SET_PRINTER_URL,
} from "../constants/actionTypesTpos";
import {
  PrinterAction,
  SetPrinterHostAction,
  SetPrinterUrlAction,
} from "../types/printer";

export type PrinterStateType = {
  printerHost: string;
  printerUrl: string;
};

const INITIAL_STATE: PrinterStateType = {
  printerHost: "",
  printerUrl: "",
};

const setPrinterHost = ({
  action,
  draft,
}: ImmerActionInput<SetPrinterHostAction, PrinterStateType>) => {
  draft.printerHost = action.payload;
};

const setPrinterUrl = ({
  action,
  draft,
}: ImmerActionInput<SetPrinterUrlAction, PrinterStateType>) => {
  draft.printerUrl = action.payload;
};

export default produce(
  (draft: PrinterStateType, action: PrinterAction): PrinterStateType => {
    switch (action.type) {
      case SET_PRINTER_HOST:
        setPrinterHost({ action, draft });
        break;
      case SET_PRINTER_URL:
        setPrinterUrl({ action, draft });
        break;
      default:
      // noop
    }
    return draft;
  },
  INITIAL_STATE,
);
